<template>
  <div class="footer__socials">
    <div class="container-fluid">
      <a
          href="#"
          target="_blank"
          title="Stadtwerke Ahrensburg @ Whatsapp"
      >
        <span>
          <FontAwesomeIcon
              :icon="faWhatsapp"
              style="color: #76B82A"
          />
        </span>
        <span>
          Whatsapp
        </span>
      </a>
      <a
          href="https://www.facebook.com/stadtwerkeahrensburg"
          target="_blank"
          title="Stadtwerke Ahrensburg @ Facebook"
      >
        <span>
          <FontAwesomeIcon
              :icon="faFacebook"
              style="color: #1877F2"
          />
        </span>
        <span>
          Facebook
        </span>
      </a>
      <a
          href="https://www.instagram.com/stadtwerke_ahrensburg/"
          target="_blank"
          title="Stadtwerke Ahrensburg @ Instagram"
      >
        <span>
          <FontAwesomeIcon
              :icon="faInstagram"
              style="color: #F93F4D"
          />
        </span>
        <span>
          Instagram
        </span>
      </a>
      <a
          href="https://www.kununu.com/de/stadtwerke-ahrensburg"
          target="_blank"
          title="Stadtwerke Ahrensburg @ Kununu"
      >
        <span>
          <svg class="custom-icon--kununu" viewBox="0 0 49 24"><path clip-rule="evenodd" d="M42.0381 23.0378C40.2801 23.0378 38.5941 22.3159 37.351 21.031C36.1079 19.7461 35.4095 18.0033 35.4095 16.1862V16.1788L35.4381 6.85087C35.4377 6.28692 35.2206 5.74623 34.8346 5.34774C34.4485 4.94924 33.9251 4.72559 33.3795 4.72598C32.834 4.72638 32.3109 4.95078 31.9254 5.34982C31.5398 5.74887 31.3235 6.28988 31.3238 6.85382V6.8612L31.2953 16.1906C31.2947 18.0078 30.5958 19.7503 29.3523 21.0348C28.1088 22.3193 26.4226 23.0406 24.6646 23.04C22.9065 23.0394 21.2208 22.317 19.9781 21.0316C18.7354 19.7463 18.0376 18.0033 18.0381 16.1862V16.1788L18.0667 6.85057C18.0663 6.28663 17.8491 5.74595 17.4631 5.34748C17.077 4.94902 16.5536 4.72541 16.008 4.72584C15.4624 4.72627 14.9393 4.95071 14.5538 5.34978C14.1683 5.74886 13.952 6.28988 13.9524 6.85382V6.8612L13.9238 16.1906C13.9227 17.5451 13.5333 18.8688 12.8047 19.9945C12.076 21.1203 11.041 21.9976 9.83022 22.5156C8.61947 23.0335 7.28736 23.169 6.00217 22.9047C4.71699 22.6405 3.5364 21.9885 2.60956 21.031C1.99186 20.3964 1.50208 19.6414 1.16858 18.8098C0.83509 17.9782 0.664506 17.0864 0.666708 16.1862L0.666708 8.77345C0.666708 8.14685 0.907524 7.5459 1.33618 7.10283C1.76483 6.65975 2.34621 6.41083 2.95242 6.41083C3.55863 6.41083 4.14001 6.65975 4.56866 7.10283C4.99732 7.5459 5.23813 8.14685 5.23813 8.77345V16.1862C5.23813 16.7501 5.45487 17.291 5.84066 17.6897C6.22645 18.0885 6.74969 18.3125 7.29528 18.3125C7.84086 18.3125 8.36411 18.0885 8.7499 17.6897C9.13568 17.291 9.35242 16.7501 9.35242 16.1862V16.1788L9.38099 6.84939C9.38156 5.03223 10.0805 3.28973 11.324 2.00522C12.5675 0.720713 14.2537 -0.000587085 16.0117 3.58539e-07C17.7697 0.000587802 19.4555 0.723015 20.6982 2.00836C21.9409 3.2937 22.6387 5.03666 22.6381 6.85382V6.8612L22.6096 16.1891C22.6099 16.7531 22.827 17.2938 23.2131 17.6923C23.5991 18.0908 24.1225 18.3144 24.6681 18.314C25.2137 18.3136 25.7368 18.0892 26.1223 17.6902C26.5078 17.2911 26.7242 16.7501 26.7238 16.1862V16.1788L26.7524 6.84939C26.753 5.03223 27.4519 3.28973 28.6954 2.00522C29.9389 0.720713 31.6251 -0.00058694 33.3831 5.03103e-07C35.1411 0.000587947 36.8269 0.723015 38.0696 2.00836C39.3123 3.2937 40.0101 5.03666 40.0095 6.85382V6.8612L39.981 16.1894C39.9814 16.7534 40.1985 17.2941 40.5846 17.6925C40.9707 18.091 41.4941 18.3146 42.0397 18.3142C42.5853 18.3137 43.1084 18.0893 43.4938 17.6902C43.8793 17.2911 44.0957 16.7501 44.0953 16.1862V8.77493C44.0953 8.14832 44.3361 7.54738 44.7647 7.1043C45.1934 6.66122 45.7748 6.41231 46.381 6.41231C46.9872 6.41231 47.5686 6.66122 47.9972 7.1043C48.4259 7.54738 48.6667 8.14832 48.6667 8.77493V16.1862C48.6667 18.0033 47.9683 19.7461 46.7252 21.031C45.4821 22.3159 43.7961 23.0378 42.0381 23.0378Z" fill="#ffc217" fill-rule="evenodd"></path></svg>
        </span>
        <span>
          Kununu
        </span>
      </a>
      <a
          href="https://www.xing.com/pages/stadtwerkeahrensburggmbh"
          target="_blank"
          title="Stadtwerke Ahrensburg @ Xing"
      >
        <span>
          <FontAwesomeIcon
              :icon="faXing"
              style="color: #126567"
          />
        </span>
        <span>
          Xing
        </span>
      </a>
      <a
          href="https://www.linkedin.com/company/stadtwerke-ahrensburg-gmbh/mycompany/"
          target="_blank"
          title="Stadtwerke Ahrensburg @ LinkedIn"
      >
        <span>
          <FontAwesomeIcon
              :icon="faLinkedin"
              style="color: #0a66c2"
          />
        </span>
        <span>
          LinkedIn
        </span>
      </a>
      <a
          href="https://www.youtube.com/@stadtwerkeahrensburg7337"
          target="_blank"
          title="Stadtwerke Ahrensburg @ Youtube"
      >
        <span>
          <FontAwesomeIcon
              :icon="faYoutube"
              style="color: #FF0000"
          />
        </span>
        <span>
          Youtube
        </span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebook,
  faWhatsapp,
  faInstagram,
  faXing,
  faLinkedin,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';

library.add(faFacebook, faWhatsapp, faInstagram, faXing, faLinkedin, faYoutube);
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.footer__socials {
  border-top: 5px solid #FFFFFF;

  .container-fluid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 0 25px;

    @media (min-width: map_get($grid-breakpoints, 'lg')) {
      gap: 0 50px;
    }
  }

  a {
    flex: 0 0 auto;
    max-width: 100%;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    padding: 18px 0 16px;
    gap: 5px;

    @media (min-width: map_get($grid-breakpoints, 'lg')) {
      gap: 10px;
      padding: 25px 0;
    }

    &, &:hover, &:visited {
      color: $body-color;
      text-decoration: none;
    }

    > span {
      display: block;

      &:first-child {
        grid-column: 1 / 2;
        font-size: 1.625rem;

        @media (min-width: map_get($grid-breakpoints, 'lg')) {
          font-size: 1.875rem;
        }

        .custom-icon {
          &--kununu {
            display: block;
            height: 1em;
            width: 2.041667em;
          }
        }
      }

      &:last-child {
        grid-column: 2 / 3;
        font-size: .75rem;
        font-weight: 700;

        @media (min-width: map_get($grid-breakpoints, 'lg')) {
          font-size: 1.125rem;
        }
      }
    }
  }
}
</style>
